import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';
import { Environment } from 'src/environments/environment.model';

@Component({
  selector: 'app-bonda-obc-dashboard',
  templateUrl: './bonda-obc-dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PowerbiReportComponent],
})
export class BondaObcDashboardComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  public readonly workspaceId: string;
  public readonly reportId: string;

  constructor() {
    this.workspaceId = this.env.BONDA_OBC_WORKSPACE_ID;
    this.reportId = this.env.BONDA_OBC_REPORT_ID;
  }
}
